import { Toaster as Sonner, toast } from "sonner"
import { colors } from '../../styles/colors';

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      position="top-right"
      className="toaster group"
      toastOptions={{
        style: {
          fontFamily: 'inherit',
          borderRadius: '16px',
          padding: '14px 18px',
          boxShadow: '0 8px 32px rgba(38, 20, 81, 0.18)',
        },
        classNames: {
          toast: "group toast",
          description: "text-sm opacity-80",
        },
        unstyled: false,
      }}
      style={{
        '--normal-bg': colors.dark,
        '--normal-text': '#FFFFFF',
        '--normal-border': colors.primary,
        '--success-bg': colors.dark,
        '--success-text': colors.lime,
        '--success-border': colors.lime,
        '--error-bg': '#3B0F0F',
        '--error-text': '#FCA5A5',
        '--error-border': colors.error,
        '--warning-bg': '#451A03',
        '--warning-text': '#FCD34D',
        '--warning-border': colors.warning,
        '--info-bg': colors.dark,
        '--info-text': colors.accent,
        '--info-border': colors.accent,
      }}
      {...props} />
  );
}

export { Toaster, toast }
